import fetch from "cross-fetch"

import { getDefaultHeaders, handleErrors } from "core/api"
import endpoints from "core/endpoints"

class LibraryCategoriesAPI {
  fetchList() {
    return handleErrors(
      fetch(endpoints.libraryCategoriesList(), {
        method: "get",
        headers: getDefaultHeaders(),
        mode: "cors",
      })
    )
  }
}

export default new LibraryCategoriesAPI()
